<template>
  <div class='ui-default-view tw-min-h-screen tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-6 tw-px-32'>
    <h1 style='font-size: 1.5rem;'>
        It looks like your account doesn't have access to this feature. Advisor Core lets you automatically extract holdings from a brokerage statement, view portfolio analytics on risk alignment, returns, volatility, etc., and generate a client-ready investment proposal. Learn more <a href="https://www.yourstake.org/advisor-core/portfolio-analysis-and-proposal-generation" target="_blank" rel="noopener noreferrer">here</a>.
    </h1>
    <p>
        Please email
        <a href="mailto:support@yourstake.org">support@yourstake.org</a>
        to learn more and request access
    </p>
  </div>
</template>


<script>
// import SubComponent from '../components/SubComponent'

export default {
  name: 'feature-access-denied',
  components: { /* Subcomponents */ },
  props: [/* Inputs */],
  data() {
    return { /* Local variables */ };
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  updated() {},
  computed: { /*
      Creates a new property
      Updates when any dependant property changes */
  },
  watch: { /*
      Watches an existing property
      Only runs when the watched property changes */
  },
  methods: {},
};
</script>


<style scoped>

</style>
  